import { NgClass } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { faFileExport, faFileImport, faSave } from '@fortawesome/free-solid-svg-icons';
import { FileUploader } from 'ng2-file-upload';
import { BehaviorSubject } from 'rxjs';
import { FormMode } from 'src/app/controls/common/form-mode';
import { EnumHelper } from 'src/app/helpers/enum-helper';
import { Rights } from 'src/app/models/enums/rights';
import { IRole } from 'src/app/models/interfaces/role.interface';
import { DefaultHttpService } from 'src/app/services/default-http.service';
import { MemoryService } from 'src/app/services/memory.service';
import { RoleFormContext } from '../role-form-context';
import { RoleRightsTrComponent } from '../role-rights-tr/role-rights-tr.component';
import { SimpleRoleRightTrComponent } from '../simple-role-right-tr/simple-role-right-tr.component';

@Component({
    selector: 'app-role-rights-form',
    templateUrl: './role-rights-form.component.html',
    styleUrls: ['./role-rights-form.component.scss'],
    imports: [NgClass, RoleRightsTrComponent, SimpleRoleRightTrComponent, MatButtonModule]
})
export class RoleRightsFormComponent extends DefaultHttpService implements OnInit {
    public faFileExport = faFileExport;
    public faFileimport = faFileImport;
    public faSave = faSave;

    /**
     * Mode d'affichage du formulaire (consultation / edition / création)
     */
    public FormMode = FormMode;

    /**
     * Enum des droits.
     */
    public Rights = Rights;

    /**
     * Infos du role à afficher dans le formulaire.
     */
    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input('role')
    public dataInput: Required<IRole> | null | undefined;

    /**
     * Indique si le formulaire est active
     */
    @Input()
    public disabled: boolean;

    /**
     * Contexte du formulaire (mode d'affichage ...).
     */
    public _context: RoleFormContext;

    /**
     * Utilisé pour propager des changements de contexte.
     */
    public _context$: BehaviorSubject<RoleFormContext> = new BehaviorSubject(null);

    /**
     * Appellé par le composant parent pour specifier un nouveau contexte.
     */
    @Input()
    set context(value: RoleFormContext) {
        this._context$.next(value);
    }

    /**
     * Emis lorsque le formulaire est mis à jour (clic sur le bouton sauver)
     */
    // eslint-disable-next-line @angular-eslint/no-output-rename
    @Output('roleRightsUpdated')
    public dataOutput: EventEmitter<IRole> = new EventEmitter();

    @Output()
    public roleRightsExported: EventEmitter<Boolean> = new EventEmitter();

    @Output()
    public roleRightsImported: EventEmitter<Boolean> = new EventEmitter();

    /**
     * Emis lorsque le formulaire est annuler(clic sur le bouton annuler)
     */
    @Output()
    public canceled: EventEmitter<boolean> = new EventEmitter();

    // Accès au enfant de type fileToUpload
    @ViewChild('fileToUpload', { static: true }) fileToUploadVariable: ElementRef;

    // Composant FileUploaderCustom
    public uploader: FileUploader = null;

    /**
     *
     * @param rolesService : Service métier utilisé pour gérer les roles.
     */
    constructor(
        public enumHelper: EnumHelper,
        public override memoryService: MemoryService
    ) {
        super(memoryService);
    }

    /**
     * Initialise le composant.
     */
    ngOnInit() {
        // S'abonne aux changements de contexte
        this._context$.subscribe((x) => {
            this._context = x;
        });

        this.uploader = new FileUploader({
            url: `${this.baseUrl}/api/organizations/${this.organizationId}/roles/${this._context.item.id}/rights/import`,
            authTokenHeader: 'Authorization',
            authToken: `Bearer ${this.connectedUser.token.accessToken}`,
            allowedFileType: ['xls'],
            queueLimit: 1,
        });

        this.uploader.onAfterAddingFile = (fileItem) => {
            fileItem.withCredentials = false;
        };

        this.uploader.onCompleteAll = () => {
            this.roleRightsImported.emit(true);
        };
    }

    public onFileSelected() {
        this.uploader.uploadAll();
    }

    /*
     * Changement des valeurs des droits
     */
    checkboxChanged(rights: Rights[]) {
        this.dataInput.rights = rights; //this.dataInput.roleRights.filter(x => !!roleRights.find(x => x));
    }

    /**
     *  Appellé lorsque l'utilisateur clique sur le bouton 'sauver'
     */
    public manualSave(): void {
        this.dataOutput.emit(this.dataInput);
    }

    public onExported() {
        this.roleRightsExported.emit(true);
    }

    public hasRight(right: Rights) {
        this.memoryService.getConnectedUser().hasRight(right);
    }

    public cancel(): void {
        this.canceled.emit(true);
    }
}
